import Rooms from './rooms'
import Ajax from '../components/ajax'
import Modal from '../components/modal'
import { useForm } from 'react-hook-form'
import Loading from '../components/loading'
import { useTranslation } from 'react-i18next'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { branchesAdd } from '../store/slices/mainSlices'
import { userLogin } from '../store/slices/mainSlices'

import editIcon from '../images/edit.png'
import deleteIcon from '../images/delete.png'

export default function Branches() {
  //Translate initialization
  const { t } = useTranslation()
  document.title = 'Branches | ' + t('name')

  //Modal for add new
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange',
  })

  //Modal for edit
  const {
    register: register2,
    handleSubmit: handleSubmit2,
    setValue: setValue2,
    getValues,
    formState: { errors: errors2, isValid: isValid2 },
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      editValues: {
        name: '',
        type: '',
      },
    },
    reValidateMode: 'onChange',
  })

  //State manager initialization
  const dispatch = useDispatch()
  const [editId, setEditId] = useState()
  const [editCode, setEditCode] = useState()
  const [modalAdd, setModalAdd] = useState(false)
  const [modalEdit, setModalEdit] = useState(false)
  const [roomsAjax, setRoomsAjax] = useState(false)
  const [roomsList, setRoomsList] = useState(false)
  const [titleBranch, setTitleBranch] = useState('')
  const [modalRooms, setModalRooms] = useState(false)
  const allBranches = useSelector(state => state.mainReducer.branches)

  //Request for add new Branch
  const onSubmitSave = data => {
    const ajaxUrl = 'manager/branches/add'
    const ajaxBody = {
      name: data.branchesName,
      type: data.branchesType,
    }
    const method = 'post'

    const promise = new Promise((resolve, reject) => {
      Ajax(ajaxBody, ajaxUrl, resolve, method)
    })

    promise.then(data => {
      const dataResponse = data.responseCode.responseCode
      if (dataResponse === '1') {
        reset()
        setModalAdd(false)
        const newBranch = {
          id: data.data.id,
          name: data.data.name,
          type: data.data.type,
          code: data.data.code,
        }
        const newArrayBranches = allBranches.slice()
        newArrayBranches.unshift(newBranch)
        dispatch(branchesAdd(newArrayBranches))
      } else if (dataResponse === '105' || dataResponse === '104' || dataResponse === '103') {
        dispatch(userLogin(false))
        localStorage.removeItem('userToken')
        localStorage.removeItem('userLogin')
      } else {
        console.log(data.responseCode.responseCode)
      }
    })
  }

  //Request for all Branches
  useEffect(() => {
    const ajaxBody = {}
    const method = 'post'
    const ajaxUrl = 'manager/branches/getAll'

    const promise = new Promise((resolve, reject) => {
      Ajax(ajaxBody, ajaxUrl, resolve, method)
    })

    promise.then(data => {
      const dataResponse = data.responseCode.responseCode
      if (dataResponse === '1') {
        dispatch(branchesAdd(data.data))
      } else if (dataResponse === '105' || dataResponse === '104' || dataResponse === '103') {
        dispatch(userLogin(false))
        localStorage.removeItem('userToken')
        localStorage.removeItem('userLogin')
      } else {
        console.log(data.responseCode.responseCode)
      }
    })
  }, [dispatch])

  //Request for delete Branch
  const deleteBranch = event => {
    const ajaxUrl = 'manager/branches/delete'
    const ajaxBody = {
      id: event.target.dataset.value,
    }
    const method = 'post'

    const promise = new Promise((resolve, reject) => {
      Ajax(ajaxBody, ajaxUrl, resolve, method)
    })

    promise.then(data => {
      const dataResponse = data.responseCode.responseCode
      if (dataResponse === '1') {
        const newDeleteArray = allBranches.slice()
        const indexDelete = newDeleteArray.indexOf(newDeleteArray.find(child => child.id === Number(event.target.dataset.value)))
        newDeleteArray.splice(indexDelete, 1)
        dispatch(branchesAdd(newDeleteArray))
      } else if (dataResponse === '105' || dataResponse === '104' || dataResponse === '103') {
        dispatch(userLogin(false))
        localStorage.removeItem('userToken')
        localStorage.removeItem('userLogin')
      } else {
        console.log(data.responseCode.responseCode)
      }
    })
  }

  //Request for edit Branch
  const oneBranch = event => {
    const ajaxUrl = 'manager/branches/getOne'
    const ajaxBody = {
      id: event.target.dataset.value,
    }
    const method = 'post'

    setEditId(event.target.dataset.value)
    setEditCode(event.target.dataset.code)
    const promise = new Promise((resolve, reject) => {
      Ajax(ajaxBody, ajaxUrl, resolve, method)
    })

    promise.then(data => {
      const dataResponse = data.responseCode.responseCode
      if (dataResponse === '1') {
        const resultArray = data.data
        const newEditArray = Object.keys(data.data)
        for (const key of newEditArray) {
          if (resultArray[key] === null) {
            resultArray[key] = ''
          }
        }
        setModalEdit(true)
        setValue2(
          'editValues',
          {
            name: resultArray.name,
            type: resultArray.type,
          },
          { shouldValidate: true }
        )
      } else if (dataResponse === '105' || dataResponse === '104' || dataResponse === '103') {
        dispatch(userLogin(false))
        localStorage.removeItem('userToken')
        localStorage.removeItem('userLogin')
      } else {
        console.log(data.responseCode.responseCode)
      }
    })
  }

  const editBranch = data => {
    const ajaxUrl = 'manager/branches/update'
    const ajaxBody = {
      id: Number(editId),
      name: data.editValues.name,
      type: data.editValues.type,
    }
    const method = 'post'

    const promise = new Promise((resolve, reject) => {
      Ajax(ajaxBody, ajaxUrl, resolve, method)
    })

    promise.then(data => {
      const dataResponse = data.responseCode.responseCode
      if (dataResponse === '1') {
        const newArrayBranches = allBranches.slice()
        const currentEditBranches = newArrayBranches.indexOf(newArrayBranches.find(child => child.id === Number(editId)))
        newArrayBranches[currentEditBranches] = {
          id: Number(editId),
          name: ajaxBody.name,
          type: ajaxBody.type,
          code: editCode,
        }
        dispatch(branchesAdd(newArrayBranches))
        setModalEdit(false)
      } else if (dataResponse === '105' || dataResponse === '104' || dataResponse === '103') {
        dispatch(userLogin(false))
        localStorage.removeItem('userToken')
        localStorage.removeItem('userLogin')
      } else {
        console.log(data.responseCode.responseCode)
      }
    })
  }

  //Get rooms modal
  const getRooms = event => {
    const ajaxUrl = 'manager/rooms/getAll'
    const ajaxBody = {
      branch_id: event.target.closest('.item').querySelector('.itemButtons button').dataset.value,
    }
    const method = 'post'

    const promise = new Promise((resolve, reject) => {
      Ajax(ajaxBody, ajaxUrl, resolve, method)
    })

    promise.then(data => {
      const dataResponse = data.responseCode.responseCode
      if (dataResponse === '1') {
        setModalRooms(true)
        setTitleBranch(event.target.closest('.item').querySelector('.titleBranch').textContent)
        setRoomsAjax(data)
        setRoomsList(data.data)
      } else if (dataResponse === '105' || dataResponse === '104' || dataResponse === '103') {
        dispatch(userLogin(false))
        localStorage.removeItem('userToken')
        localStorage.removeItem('userLogin')
      } else {
        console.log(data.responseCode.responseCode)
      }
    })
  }
  //Initialization loading
  const branches = allBranches ? (
    Object.values(allBranches).map(child => {
      return (
        <div className='item' key={child.id} onClick={event => getRooms(event)}>
          <p title={child.name} className='titleBranch'>
            {child.name}
          </p>
          <p>{child.type === '1' ? 'Man' : 'Woman'}</p>
          <p>{child.code}</p>
          <div className='itemButtons'>
            <button
              data-value={child.id}
              data-code={child.code}
              onClick={function (event) {
                event.stopPropagation()
                oneBranch(event)
              }}>
              <img src={editIcon} alt='edit icon' data-value={child.id} data-code={child.code} />
            </button>
            <button
              data-value={child.id}
              onClick={function (event) {
                event.stopPropagation()
                deleteBranch(event)
              }}>
              <img src={deleteIcon} alt='delete icon' data-value={child.id} />
            </button>
          </div>
        </div>
      )
    })
  ) : (
    <Loading />
  )
  return (
    <section className='branches'>
      <div className='addNew'>
        <h2>Branches</h2>
        <button value='addNew' onClick={() => setModalAdd(true)}>
          Add
        </button>
      </div>
      <div className='table' style={!allBranches ? { justifyContent: 'center', display: 'flex' } : null}>
        {branches}
      </div>
      <Modal active={modalAdd} setActive={setModalAdd}>
        <h2>Branches info</h2>
        <form onSubmit={handleSubmit(onSubmitSave)} autoComplete='off'>
          <label>
            <p>
              Name <span className='requiredInput'>*</span>
            </p>
            <input
              {...register('branchesName', {
                required: 'This field is required',
                minLength: {
                  value: 3,
                  message: 'Min length 3',
                },
                maxLength: {
                  value: 50,
                  message: 'Max length 50',
                },
              })}
            />
          </label>
          <span className='errorResponse'>{errors.branchesName && errors.branchesName.message}</span>
          <label>
            <p>Type</p>
            <select
              {...register('branchesType', {
                required: 'This field is required',
              })}>
              <option value='2'>Woman</option>
              <option value='1'>Man</option>
            </select>
          </label>
          <span className='errorResponse'>{errors.branchesType && errors.branchesType.message}</span>
          <div className='buttons'>
            <input type='submit' className='sendButton' value='Save' disabled={!isValid} />
            <span className='sendButton' onClick={() => setModalAdd(false)}>
              Cancel
            </span>
          </div>
        </form>
      </Modal>
      <Modal active={modalEdit} setActive={setModalEdit}>
        <h2>Branches info</h2>
        <form onSubmit={handleSubmit2(editBranch)} autoComplete='off'>
          <label>
            <p>
              Name <span className='requiredInput'>*</span>
            </p>
            <input
              {...register2('editValues.name', {
                required: 'This field is required',
                minLength: {
                  value: 3,
                  message: 'Min length 3',
                },
                maxLength: {
                  value: 50,
                  message: 'Max length 50',
                },
              })}
            />
          </label>
          <span className='errorResponse'>
            {errors2.hasOwnProperty('editValues') && errors2.editValues.hasOwnProperty('name') ? errors2.editValues.name.message : null}
          </span>
          <label>
            <p>Type</p>
            <select
              {...register('editValues.type', {
                required: 'This field is required',
              })}>
              <option value='2'>Woman</option>
              <option value='1' selected={getValues('editValues.type') === '1' ? 'selected' : null}>
                Man
              </option>
            </select>
          </label>
          <span className='errorResponse'>
            {errors2.hasOwnProperty('editValues') && errors2.editValues.hasOwnProperty('type') ? errors2.editValues.type.message : null}
          </span>
          <div className='buttons'>
            <input type='submit' className='sendButton' value='Save' disabled={!isValid2} />
            <span className='sendButton' onClick={() => setModalEdit(false)}>
              Cancel
            </span>
          </div>
        </form>
      </Modal>
      <Modal active={modalRooms} setActive={setModalRooms}>
        <Rooms
          roomsAjax={roomsAjax}
          setModalRooms={setModalRooms}
          modalRooms={modalRooms}
          titleBranch={titleBranch}
          setRoomsAjax={setRoomsAjax}
          setRoomsList={setRoomsList}
          roomsList={roomsList}
        />
      </Modal>
    </section>
  )
}
